<template>
    <div>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">
                <vs-button
                    id="addType"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter un nouveau type de campagne
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource"
                    @close="resetResource"
                    @accept="saveResource"
                >
                     <CampaignTypeForm
                        v-model="resource"
                        @error="setFormError"
                    />
                </DialogPrompt>

            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-row class="mt-3">
            <vs-col vs-w="12">
                <vs-table
                    :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
                    style="width:100%"
                    :data="types"
                    :loading="true"
                    >
                    <template slot="thead">
                        <vs-th>
                            <Sort name="document_date" @sort="eventSortByCol">Nom</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="thematic" @sort="eventSortByCol">Délai de contribution</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="title" @sort="eventSortByCol">Délai de publication</Sort>
                        </vs-th>
                        <vs-th>
                            Anonymisation ?
                        </vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr v-for="(item, i) in data" :key="i">
                            <vs-td>
                                {{ get(item, ':name') }}
                            </vs-td>
                            <vs-td>
                                {{ get(item, ':contribution_delay') }}
                            </vs-td>
                            <vs-td>
                                {{ get(item, ':publication_delay') }}
                            </vs-td>
                            <vs-td>
                                {{ get(item, ':anonymous') ? '&#10003;' : '' }}
                            </vs-td>
                            <vs-td class="action">
                                <div class="action-wrapper">
                                    <vs-button
                                        v-if="can('update', 'campaign_types', item.id)"
                                        v-tooltip="'Modifier'"
                                        color="primary"
                                        type="border"
                                        icon-pack="feather"
                                        icon="icon-edit"
                                        @click.stop="showFormUpdate(item)"
                                    />

                                    <vs-button
                                        v-if="can('delete', 'campaign_types', item.id)"
                                        v-tooltip="'Supprimer'"
                                        color="primary"
                                        type="border"
                                        icon-pack="feather"
                                        icon="icon-trash"
                                        @click.stop="removeResource(item)"
                                    />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>

                </vs-table>
            </vs-col>
        </vs-row>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>

</template>

<script>

import CampaignTypeForm from "./CampaignTypeForm.vue"

export default {
    name: 'CampaignTypes',
    components: {
        CampaignTypeForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            log: console.log,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            isFormCreation: true,
            resource: {
                name: null,
                contribution_delay: null,
                publication_delay: null,
            },
            formError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter un type de Campagne',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter un type de Campagne',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier un type de Campagne',
                    btnAccept: 'filled'
                }
            },
            types: []
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },
    },

    methods: {
        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        saveResource() {
            let data = JSON.parse(JSON.stringify(this.resource));
            data.file = this.resource.file;

            if (data.id) {
                this.apiUpdate(data, data.id,
                    (resp) => this.loadTypes(),
                    (err)  => this.showPopup = true
                );
            } else {
                this.apiCreate(data,
                    (resp) => this.loadTypes(),
                    (err)  => this.showPopup = true
                );
            }
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadTypes());
        },

        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },

        resetResource() {
            this.resource = {
                name: null,
                contribution_delay: null,
                publication_delay: null,
                anonymous: false
            }
        },

        setFormError (value) {
            this.formError = value;
        },

        loadTypes() {
            window.axios({
                method: 'get',
                url: this.api,
            })
            .then(response => {
                this.loading = false
                this.types = response.data;
            })
            .catch((err) => {
                this.loading = false
                this.notifyError(err, `Une erreur est survenue`)
            })
        }
    },
    created() {
        this.loadTypes()
    }
}
</script>
